// extracted by mini-css-extract-plugin
export var locationCard = "_hd-0";